const DIALOG_SIZE = 'xl'
export default DIALOG_SIZE
